import React from "react";

interface TabNavigationProps {
  activeTab: "installed" | "browse";
  setActiveTab: (tab: "installed" | "browse") => void;
  installedApps: any[];
}

const TabNavigation: React.FC<TabNavigationProps> = ({
  activeTab,
  setActiveTab,
  installedApps,
}) => (
  <div className="flex border-b py-1">
    <button
      className={`flex items-center justify-center gap-2 px-4 py-2 text-sm ${
        activeTab === "installed"
          ? "text-white font-medium border-b-2 border-white"
          : "text-[#8E8E8E] font-normal"
      }`}
      onClick={() => setActiveTab("installed")}
    >
      Installed{" "}
      {installedApps?.length > 0 && (
        <div className="px-[8px] w-fit rounded bg-[#6F55F2] py-[2px]">
          <p className="text-xs text-white">{installedApps?.length}</p>
        </div>
      )}
    </button>
    <button
      className={`pl-4 py-2 text-sm ${
        activeTab === "browse"
          ? "text-white font-medium border-b-2 border-white"
          : "text-[#8E8E8E] font-normal"
      }`}
      onClick={() => setActiveTab("browse")}
    >
      Browse
    </button>
  </div>
);

export default TabNavigation;
